export enum NotificationEventName {
  COMPLETE_PROFILE = 'complete_profile',
  CREATE_FIRST_TASK = 'create_first_task',
  NEW_OFFER_RECEIVED = 'new_offer_received',
  NEW_OFFER_REQUEST_RECEIVED = 'new_offer_request_received',
  NO_OFFERS_IN_24H = 'no_offers_in_24h',
  NO_OFFER_ACCEPTED = 'no_offer_accepted',
  NOT_ENOUGH_OFFERS_IN_48H = 'not_enough_offers_in_48h',
  OFFER_ACCEPTED = 'offer_accepted',
  OFFER_REQUEST_CREATED = 'offer_request_created',
  OFFER_REQUEST_OFFER_MADE = 'offer_request_offer_made',
  OFFER_REQUEST_ACCEPTED = 'offer_request_accepted',
  OFFER_REJECTED = 'offer_rejected',
  OFFER_INCREASE_BY_PP = 'offer_increase_by_PP',
  OFFER_INCREASE_BY_TO = 'offer_increase_by_TO',
  OFFER_INCREASE_ACCEPTED = 'offer_increase_accepted',
  OFFER_INCREASE_CANCELED = 'offer_increase_canceled',
  OFFER_CHOICE_RECOMMENDATION = 'offer_choice_recommendation',
  REVIEW_RECEIVED = 'review_received',
  TASK_COMPLETED = 'task_completed',
  REQUEST_COMPLETION = 'request_completion',
  PENALTY_APPLIED = 'penalty_applied',
  PICK_OFFER_REMINDER = 'pick_offer_reminder',
  NEW_COMMENT_RECEIVED = 'new_comment_received',
  NEW_OFFER_COMMENT_RECEIVED = 'new_offer_comment_received',
  NEW_COMMENT_ON_FOLLOWED_TASK = 'new_comment_on_followed_task',
  OFFER_EDIT = 'offer_edit',
  OFFER_CANCELED = 'offer_canceled',
  TASK_CANCELLATION_REQUESTED = 'task_cancellation_requested',
  TASK_CANCELLATION_ACCEPTED = 'task_cancellation_accepted',
  TASK_CANCELLATION_DENIED = 'task_cancellation_denied',
  TASK_CANCELLATION_UNDO = 'task_cancellation_undo',
  TASK_CANCELED = 'task_canceled',
  TASK_EXPIRED = 'task_expired',
  TASK_ACCEPTED_EXPIRED = 'task_accepted_expired',
  VERIFICATION_NEED = 'verification_need',
  NEW_MESSAGE = 'new_message',
  NEW_DAILY_TASKS = 'new_daily_tasks',
  NEW_HOURLY_TASKS = 'new_hourly_tasks',
  NEW_TASK = 'new_task',
  REQUEST_OFFER = 'request_offer',
  BOOK_AGAIN = 'book_again',
  PRICE_REDUCTION = 'price_reduction',
  HH_LIMITATIONS_CHANGED = 'hh_limitations_changed',
  CENSOR = 'censor',
  SUPPORT_TICKET_ANSWER = 'support_ticket_answer',
  BAN_VIOLATING_COMPLETION_RATE = 'ban_violating_completion_rate',
  CONTACT_US = 'CONTACT_US',
  CUSTOM_TRUSTPILOT = 'custom_trustpilot',
  INACTIVE_USER_SMS_NEW_TASK_INSTANT = 'inactive_user_sms_new_task_instant',
  INACTIVE_USER_SMS_NEW_TASK_DAILY = 'inactive_user_sms_new_task_daily',
  VERIFICATION_TOKEN = 'verification_token',
  END2END_TEST_REPORT = 'end2end_test_report',
  BAN_FIRST_CANCEL_TASK = 'ban_first_cancel_task',
  BAN_SECOND_CANCEL_TASK = 'ban_second_cancel_task',
  BAN_THIRD_CANCEL_TASK = 'ban_third_cancel_task',
  CREATE_SUPPORT_TICKET = 'create_support_ticket',
  CREATE_SUPPORT_TICKET_FROM_ADMIN = 'create_support_ticket_from_admin',
  FORGOT_PASSWORD = 'forgot_password',
  PAYOUT_FAILURE = 'payout_failure',
  PAYOUT_SUCCESS = 'payout_success',
  REPORTED_USER = 'reported_user',
  TASK_EXPIRE_SOON = 'TASK_EXPIRE_SOON',
  CONFLICT_CASE_RESOLVED = 'CONFLICT_CASE_RESOLVED',
  SIMPLE_EMAIL = 'SIMPLE_EMAIL',
  ADMIN_COMPLETED_TASK = 'ADMIN_COMPLETED_TASK',
  ADMIN_BAN_USER = 'ADMIN_BAN_USER',
  ADMIN_REMOVED_PROFILE_PICTURE = 'ADMIN_REMOVED_PROFILE_PICTURE',
  ADMIN_MAIL = 'ADMIN_MAIL',
  UNREAD_MESSAGES = 'UNREAD_MESSAGES',
  NEW_GIFT_CARD = 'NEW_GIFT_CARD',
  MORE_DETAILS_REPORT_ADMIN = 'MORE_DETAILS_REPORT_ADMIN',
  REJECT_AUTOMATIC_CENSORING = 'REJECT_AUTOMATIC_CENSORING',
  ADMIN_HANDLE_REJECTED_AUTOMATED_CENSORING = 'ADMIN_HANDLE_REJECTED_AUTOMATED_CENSORING',
  CREATE_CONFLICT_CASE = 'CREATE_CONFLICT_CASE',
  CLOSE_CONFLICT_CASE = 'CLOSE_CONFLICT_CASE',
  PENDING_CONFLICT_CASE = 'PENDING_CONFLICT_CASE',
  NEAR_EXPIRED_CONFLICT_CASE = 'NEAR_EXPIRED_CONFLICT_CASE',
  FULL_CUSTOM = 'FULL_CUSTOM',
  REFERRAL_CREDIT_REFEREE = 'referral_credit_referee',
  REFERRAL_CREDIT_REFERRER = 'referral_credit_referrer',
  COMPANY_STATUS_UPDATE = 'company_status_update',
  REACTIVATION_FIRST = 'reactivation_first',
  REACTIVATION_SECOND = 'reactivation_second',
  STORED_CREDIT_EXPIRES_IN_10_DAYS = 'stored-credit-expires-in-10-days',
  STORED_CREDIT_EXPIRES_IN_5_DAYS = 'stored-credit-expires-in-5-days',
  STORED_CREDIT_EXPIRES_IN_2_DAYS = 'stored-credit-expires-in-2-days',
  TO_REACTIVATION_1 = 'to-reactivation-1',
  TO_REACTIVATION_2 = 'to-reactivation-2',
  TO_REACTIVATION_3 = 'to-reactivation-3',
  TO_REACTIVATION_4 = 'to-reactivation-4',
  TO_REACTIVATION_5 = 'to-reactivation-5',
  DATE_PROPOSED = 'date-proposed',
  DATE_ACCEPTED = 'date-accepted',
  DAY_BEFORE_REMINDER = 'day-before-reminder',
  ON_DAY_REMINDER = 'on-day-reminder',
  TASK_REOPENED = 'task-reopened',
  REHIRE_CREATED = 'rehire_created',
}
